"use client"

// Loader: the brand "stripe" streaming indicator. The horizontal-stripe motif
// (see globals.css .brand-stripes-animated) marks the in-progress state beyond
// color alone.

import { cn } from "@/lib/utils"
import type { ReactNode } from "react"

/**
 * Animated brand-stripe loader with an accessible label.
 *
 * @param label - Spanish status text announced to assistive tech and shown
 *   beside the stripes.
 * @param className - extra classes merged onto the wrapper.
 */
export function BrandLoader({
  label = "Pensando…",
  className,
}: {
  label?: string
  className?: string
}): ReactNode {
  return (
    <div role="status" aria-live="polite" className={cn("flex items-center gap-2.5", className)}>
      <span className="brand-stripes-animated h-3 w-10 rounded-sm" aria-hidden="true" />
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
  )
}
